import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cx from 'classnames';
import Icon from './Icon';
import styles from './Icon.module.scss';
const UnreadCommentIcon = ({ size = 20, className, ...rest }) => (_jsxs("div", { className: cx(styles.container, className), children: [_jsx(Icon, { size: size, name: "ic_comment", ...rest }), _jsx("div", { className: styles.counterIndicator, style: { height: Number(size) / 4, width: Number(size) / 4 } })] }));
export default UnreadCommentIcon;
